import dayjs from "dayjs";

async function sumTotalDates(data) {
  return data.reduce((sum, item) => sum + (item.total_dates || 0), 0);
}

function generateMonthlyIntervals(startDate, endDate) {
  let intervals = [];
  let start = dayjs(startDate);
  let end = dayjs(endDate);
  let includeYear = start.year() !== end.year();

  while (start.isBefore(end) || start.isSame(end, "day")) {
    let monthEnd = start.endOf("month");
    let intervalEnd = monthEnd.isAfter(end) ? end : monthEnd;

    let label = includeYear
      ? `${start.format("MMM").toUpperCase()} ${start.format("YY")}`
      : start.format("MMM").toUpperCase();

    intervals.push({
      start: start.format("YYYY-MM-DD"),
      end: intervalEnd.format("YYYY-MM-DD"),
      label: label,
    });

    start = intervalEnd.add(1, "day");
  }
  return intervals;
}

export async function getEngajamentoData(startDate, endDate, api, query) {
  const intervals = generateMonthlyIntervals(startDate, endDate);
  let result = {};

  for (const interval of intervals) {
    const queryEngajamento = `${query}&start_date=${interval.start}&end_date=${interval.end}`;
    let { data: agent_stats } = await api.get(queryEngajamento);
    agent_stats = removeNullObjects(agent_stats)
    const totalDates = await sumTotalDates(agent_stats);

    result[interval.label] = (result[interval.label] || 0) + totalDates;
  }

  const categories = Object.keys(result);
  const data = Object.values(result);

  return {
    xaxis: {
      categories: categories,
    },
    series: [
      {
        name: "Taxa de retenção",
        data: data,
      },
    ],
  };
}

export async function getSegurancaConformidadeData(startDate, endDate, api, query) {
  const intervals = generateMonthlyIntervals(startDate, endDate);
  let result = {};

  for (const interval of intervals) {
    const querySegurancaConformidade = `${query}&start_date=${interval.start}&end_date=${interval.end}`;
    const { data: agent_stats } = await api.get(querySegurancaConformidade);
    const total = agent_stats.length;

    result[interval.label] = (result[interval.label] || 0) + total;
  }

  const categories = Object.keys(result);
  const data = Object.values(result);

  return {
    xaxis: {
      categories: categories,
    },
    series: [
      {
        name: "Solicitações de redefinição de senha",
        data: data,
      },
    ],
  };
}

function calcularMediaResponseTime(arrays) {
  let totalResponseTime = 0;
  let totalCount = 0;

  arrays.forEach(array => {
    array.forEach(item => {
      if (item.response_time !== undefined) {
        totalResponseTime += item.response_time;
        totalCount++;
      }
    });
  });

  return totalCount > 0 ? (totalResponseTime / totalCount).toFixed(2) : 0;
}

export function getDesempenhoData(dados) {
  let series = [{
    name: "Tempo de resposta do sistema em segundos",
    data: [
      calcularMediaResponseTime(dados.listagens),
      calcularMediaResponseTime(dados.edicoes),
      calcularMediaResponseTime(dados.criacoes),
      calcularMediaResponseTime(dados.downloads)
    ]
  }];

  return {
    xaxis: {
      categories: ["Listagens", "Edições", "Criações", "Downloads"]
    },
    series: series
  };
}

export function getCountQueryPath(data, query) {
  return data.filter((item) => item.path.includes(query) && item.agent_cpf !== null);
}

export function getCountQueryPathById(data, index) {
  return data.filter((item) => {
    let pathParts = item.path.split("/");
    return !isNaN(pathParts[index]) && item.agent_cpf !== null;
  });
}

export function addPartQuery(partialQuery, newPart) {
  return partialQuery + newPart;
}

export function removeNullObjects(data) {
  return data.filter((item) => item.agent_cpf !== null);
}
